import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import axios from 'axios';

export const fetchOuTreeData = createAsyncThunk('ouTreeData/fetchOuTreeData', async (value) => {
  const response = await axios.get(
    `GetADDetails/ouadmintree?FQDN=${encodeURIComponent(value.fqdn)}&username=${value.name}`
  );
  return response.data;
});

// Utility function to convert array to object

const arrayToObject = (data) => {
  const initTreeData = [];
  if (!data) {
    return null;
  } else {
    data.forEach((item, index) => {
      const obj = {
        title: item.ouName,
        key: index + 1,
        dnName: item.ouDn,
      };
      initTreeData.push(obj);
    });
    return initTreeData;
  }
};

const handleAddOuInOuAdminTree = (tree, parentKey, child) => {
  return tree.map((node) => {
    if (node.key === parentKey) {
      if (node.children) {
        const filteredChildren = node.children.filter((child) => child.key);
        let newObj = {
          key: `${parentKey}-${filteredChildren.length + 1}`,
          title: child && child.ouName,
          dnName: child && child.dnName,
          hasChildren: true,
        };
        const newChildren = [
          ...node.children.slice(0, filteredChildren.length),
          newObj,
          ...node.children.slice(filteredChildren.length),
        ];
        return { ...node, children: newChildren };
      }
    } else if (node.children) {
      return {
        ...node,
        children: handleAddOuInOuAdminTree(node.children, parentKey, child),
      };
    }
    return node;
  });
};
const handleUpdateOuInOuAdminTree = (tree, oldDnName, newName, newDnName) => {
  return tree.map((node) => {
    if (node.dnName === oldDnName) {
      return {
        ...node,
        title: newName,
        dnName: newDnName,
      };
    }
    if (node.children) {
      node.children = handleUpdateOuInOuAdminTree(node.children, oldDnName, newName, newDnName);
    }
    return node;
  });
};
const handleDeleteOuInOuAdminTree = (tree, ouDnName) => {
  return tree.filter((node) => {
    if (node.dnName === ouDnName) {
      return false;
    }
    if (node.children) {
      node.children = handleDeleteOuInOuAdminTree(node.children, ouDnName);
    }
    return true;
  });
};

const initialState = {
  data: [],
  loading: false,
  error: null,
  ouAdminTreeExpandedKeys: [],
  ouAdminsTree: [],
  ouAdminNodeKey: '',
};

const ouTreeDataSlice = createSlice({
  name: 'ouTreeData',
  initialState,
  reducers: {
    setExpandedKeysOuAdmin: (state, action) => {
      state.ouAdminTreeExpandedKeys = action.payload;
    },
    setOuAdminsTree: (state, action) => {
      state.ouAdminsTree = action.payload;
    },
    setOuAdminNodekey: (state, action) => {
      state.ouAdminNodeKey = action.payload;
    },
    addOuInOuAdminTree: (state, action) => {
      state.ouAdminsTree = handleAddOuInOuAdminTree(
        state.ouAdminsTree,
        action.payload.ouAdminNodeKey,
        action.payload.child
      );
    },
    updateOuInOuAdminTree: (state, action) => {
      state.ouAdminsTree = handleUpdateOuInOuAdminTree(
        state.ouAdminsTree,
        action.payload.oldDnName,
        action.payload.newName,
        action.payload.newDnName
      );
    },
    deleteOuInOuAdminTree: (state, action) => {
      state.ouAdminsTree = handleDeleteOuInOuAdminTree(state.ouAdminsTree, action.payload);
    },
    resetOuTreeState: (state) => {
      return initialState;
    },
  },

  extraReducers: (builder) => {
    builder
      .addCase(fetchOuTreeData.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchOuTreeData.fulfilled, (state, action) => {
        state.loading = false;
        state.data = {
          name: action.payload[0].ouName,
          dnName: action.payload[0].ouDn,
        };
        state.objectData = arrayToObject(action.payload);
        state.error = null;
      })
      .addCase(fetchOuTreeData.rejected, (state, action) => {
        state.loading = false;
        state.data = [];
        state.error = action.error.message;
      });
  },
});
export const {
  setExpandedKeysOuAdmin,
  setOuAdminsTree,
  setOuAdminNodekey,
  resetOuTreeState,
  updateOuInOuAdminTree,
  deleteOuInOuAdminTree,
  addOuInOuAdminTree,
} = ouTreeDataSlice.actions;
export default ouTreeDataSlice.reducer;
